export {default} from './WeightTileGraph';
